import React, { useEffect, useState } from 'react';
import { TM_TRD_GROUP_SET, GetTrendGroupList, GroupListType } from '../../../function/GroupDataModel';
import GroupSelectGrid, { SelectGroupType } from '../../organisms/Pages/GroupSelectGrid';
import { useHistory } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import { makeStyles, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
  createStyles({
    paper: {
      padding: '10px',
      background: '#FFFFEE',
    },
    tableContainer: { maxHeight: 'calc(100vh - 210px)' },
  })
);

type Props = {
  /**
   * 初期表示時の絞り込みパラメータ
   */
  defalutGropuNos?: number[];
};

const TrendGraphGroupSelectPage: React.FC<Props> = (props) => {
  const defalutGropuNos: number[] = props.defalutGropuNos ?? [];
  const history = useHistory();
  const classes = useStyles();

  const [groupDt, setGroupDt] = useState<TM_TRD_GROUP_SET[]>([]);
  const [groupList, setGroupList] = useState<SelectGroupType[]>([]);

  useEffect(() => {
    GetTrendGroupList().then((ret) => {
      setGroupDt(ret.TM_TRD_GROUP_SETs.filter((r) => r.DSP_FLG == 1));
    });
  }, []);

  useEffect(() => {
    var lists: SelectGroupType[] = [];
    console.debug(['★defalutGropuNo★', defalutGropuNos]);
    if (defalutGropuNos.length === 0) {
      for (var i in groupDt) {
        lists.push({ index: Number(i) + 1, groupName: groupDt[i].GROUP_NAME, groupNo: groupDt[i].GROUP_NO });
      }
    } else {
      var fillterDt = groupDt.filter((row) => defalutGropuNos.find((row2) => row.GROUP_NO === row2) !== undefined);
      for (var i in fillterDt) {
        lists.push({ index: Number(i) + 1, groupName: fillterDt[i].GROUP_NAME, groupNo: fillterDt[i].GROUP_NO });
      }
    }

    setGroupList(lists);
    console.debug(lists);
  }, [groupDt]);

  const groupSelect = (selectdata: SelectGroupType) => {
    var target = groupDt.find((row) => row.GROUP_NO == selectdata.groupNo);
    history.push({
      pathname: '/TrendGraphPage',
      state: target,
    });
  };

  return <GroupSelectGrid groupList={groupList} onSelect={groupSelect} tableContainerStyle={classes.tableContainer} />;
};

export default TrendGraphGroupSelectPage;
